import React from 'react';
import { ImageBackground } from 'react-native';

import {
	AvatarGradientColor,
	AvatarLevelPosition,
	AvatarSparklePosition,
} from '../../../../typings/types';
import {
	AvatarFrameGradientBluePng,
	AvatarFrameGradientGoldPng,
	AvatarFrameGradientRedPng,
} from '../../../assets';
import { AvatarFrame } from '../index';

const AvatarFrameWithGradient = ({
	gradientColor,
	levelPosition,
	sparklePosition,
	showVipBadge,
	showUsernameFrame,
	sizeMultiplier = 1,
}: {
	gradientColor: AvatarGradientColor;
	levelPosition?: AvatarLevelPosition;
	sparklePosition?: AvatarSparklePosition;
	showVipBadge?: boolean;
	showUsernameFrame?: boolean;
	sizeMultiplier?: number;
}) => {
	const gradientSource =
		gradientColor === AvatarGradientColor.Gold
			? AvatarFrameGradientGoldPng
			: gradientColor === AvatarGradientColor.Blue
				? AvatarFrameGradientBluePng
				: AvatarFrameGradientRedPng;

	return (
		<ImageBackground
			source={gradientSource}
			style={{
				zIndex: 2,
				width: 105 * sizeMultiplier,
				height: 105 * sizeMultiplier,
			}}
		>
			<AvatarFrame
				hasGradient={true}
				levelPosition={levelPosition}
				sparklePosition={sparklePosition}
				showVipBadge={showVipBadge}
				showUsernameFrame={showUsernameFrame}
				sizeMultiplier={sizeMultiplier}
			/>
		</ImageBackground>
	);
};
export default AvatarFrameWithGradient;
